import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router';
import { App } from './App';
import { ToastContainer } from '@/presentation/components/Toast';
import { AiChatFab } from '@/presentation/components/AiChatFab';
import { PwaAutoUpdater } from '@/shared/components/PwaAutoUpdater';
import { PwaInstallPrompt } from '@/shared/components/PwaInstallPrompt';
import { OfflineBanner } from '@/shared/components/OfflineBanner';
import { load as loadI18n } from '@/infrastructure/i18n';
import './index.css';

// 立即触发翻译预加载
loadI18n();

// e2e gate — Plan 3C Phase 9。VITE_E2E_MOCK=1 时启动 msw service worker,
// 拦截 /api/tenant/** 走 e2e/setup/msw-handlers.ts。生产/普通 dev 不加载 mocks/。
async function enableMocking(): Promise<void> {
  if (!import.meta.env.VITE_E2E_MOCK) return;
  const { worker } = await import('./mocks/browser');
  // `'error'` 而不是 `'warn'`:`warn` 会把未匹配的请求**放行到真实后端**,而
  // `VITE_API_BASE` 指向的是 dev-cloud。2026-08-19 实测:一次本地 e2e 会话里
  // `/api/tenant/profile` 与 `/notifications/unread-count` 就这么打到了 dev-cloud
  // 并拿回 401。mock 后端漏到真环境这件事必须是硬失败,不是一行警告。
  await worker.start({ onUnhandledRequest: 'error' });
}

enableMocking().then(() => {
  createRoot(document.getElementById('root')!).render(
    <BrowserRouter>
      <App />
      <AiChatFab />
      <ToastContainer />
      <PwaAutoUpdater />
      <PwaInstallPrompt />
      <OfflineBanner />
    </BrowserRouter>,
  );
});
